<div class="agenx-card-create">
  <header class="agenx-card-create__header"> {{ title }}

  </header>
  <agenx-card [title]="titleForCardInside" [borderTopLess]="true">
    <ng-content></ng-content>
  </agenx-card>
</div>
